import { useSelector } from 'react-redux';
import { User } from '../types/user';

export function useUser(): User {
  const user = useSelector((store) => store.user);

  return user || {};
}
